query StreamEntrypoint($id: ID!) {
  streamEntrypoint(id: $id) {
    id
    title
    rtmpsUrl
    rtmpsStreamKey
    srtUrl
    srtStreamId
    srtPassphrase
    rtmpsPlaybackUrl
    rtmpsPlaybackStreamKey
    srtPlaybackUrl
    srtPlaybackStreamId
    srtPlaybackPassphrase
    liveConnected
    stream {
      id
      title
    }
    pull {
      sourceUrl
      status
      attempt
      maxAttempts
      startedAt
      finishedAt
      lastError {
        code
        message
      }
    }
    playback {
      token
      hlsUrl
      dashUrl
      iframeUrl
      thumbnailUrl
    }
    createdAt
    updatedAt
  }
}
